import {
  BoolFilter,
  SearchAccountsRes_Result,
} from "gen/search/service/service_pb"
import { UUID } from "shared-ts/classes/uuid"
import {
  usePopoverSelect,
  UsePopoverSelectProps,
  UsePopoverSelectRes,
} from "shared-web/components/composite/popover"

import { useSearchAccounts } from "features/api/search"

type UseAccountsPopoverSelectProps = Pick<
  UsePopoverSelectProps<SearchAccountsRes_Result>,
  "selected" | "onSelect" | "defaultSelected"
>

type UseAccountsPopoverSelectRes = UsePopoverSelectRes<SearchAccountsRes_Result>

function useAccountsPopoverSelect({
  ...otherProps
}: UseAccountsPopoverSelectProps = {}): UseAccountsPopoverSelectRes {
  const { results, setQuery } = useSearchAccounts(
    { isActiveFilter: BoolFilter.TRUE },
    { ignoreSearchQuery: true }
  )

  return usePopoverSelect({
    items: results,
    keyExtractor,
    labelExtractor,
    onChangeQuery: setQuery,
    ...otherProps,
  })
}

function keyExtractor({ account }: SearchAccountsRes_Result): string {
  if (!account) return ""
  return UUID.idString(account.id)
}

function labelExtractor({ account }: SearchAccountsRes_Result): string {
  if (!account) return ""
  return `${account.number} - ${account.name}`
}

export default useAccountsPopoverSelect
